import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

// Full GitHub-flavored markdown renderer used for question text, popups, and
// report labels — chiefly to render policy/standard links. Paragraphs are
// unwrapped to a span so short question text stays inline within its label,
// and links open in a new tab.
const components: Components = {
    p: ({ children }) => <span>{children}</span>,
    a: ({ href, children }) => (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary underline underline-offset-2 [overflow-wrap:anywhere] hover:text-primary/80"
        >
            {children}
        </a>
    ),
    ul: ({ children }) => <ul className="my-1 ml-4 list-disc space-y-0.5">{children}</ul>,
    ol: ({ children }) => <ol className="my-1 ml-4 list-decimal space-y-0.5">{children}</ol>,
    code: ({ children }) => <code className="rounded bg-muted px-1 py-0.5 text-[0.85em]">{children}</code>,
}

export function RichText({ text, className }: { text: string; className?: string }) {
    return (
        <span className={className}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
                {text}
            </ReactMarkdown>
        </span>
    )
}
